export const testId = {
    email: "email",
    forgotPassword: "forgot-password",
    forgotPasswordSubmit: "forgot-password-submit",
    login: "login",
    password: "password",
    submitEnter: "submit-enter"
} as const
